define('components/decorators/organisation-profile.js',[
  'jquery',
],function($){

  /**
   * Separates financials table rows into two columns
   */

  $.extend(companyInfo.decorators,{

    'separate-rows': function(){

      var financialsTable = $(".org-profile__financials-table");
      var secondTable = $(".org-profile__financials-table--second");
      var rows = $(".org-profile__financials-table tr.org-profile__financials-row");
      
        rows.filter(function(index) {
    
          // Only separate into two columns if there are 3 or more rows
          if (rows.length > 2) {
            var rowBreakPoint = Math.round(rows.length / 2);
            var secondColumnRows = rows.slice(rowBreakPoint);
            var secondColumnRowsLength = secondColumnRows.length;
    
            // Showing max of 18 financials, removing if there is more
            if (secondColumnRowsLength > 9) {
              var croppedRows = secondColumnRows.not(":last-child");
              secondTable.append(croppedRows);
            } else {
              secondTable.append(secondColumnRows);
            }
    
            // Initially hiding financials table to avoid flickering
            financialsTable.removeClass("org-profile__financials-table--hidden");
            financialsTable.addClass("org-profile__financials-table--visible");
          }
      });
    }
    
  });
});

